import React from 'react';
import {isValidObject} from 'src/utilities/objectUtils';
import {FormViewRow} from '../FormViewRow/FormViewRow';

export interface FormViewDateProps {
  label: string;
  value: any;
  description?: string;
}

export const FormViewDate: React.FC<FormViewDateProps> = ({
  label,
  value,
  description,
}) => {
  const displayValue = isValidObject(value) && value.label;
  const val = !value
    ? ''
    : displayValue
    ? String(displayValue).toShortDate()
    : String(value).toShortDate();

  return <FormViewRow label={label} value={val} description={description} />;
};
